module.exports = __webpack_public_path__ + "static/media/brian-cutout.fb3a1c4f.png";